export const PATHS = {
  PrivacyPolicy: "/privacy-policy",
  TermsOfUse: "/term-of-use",
  Login: "/login",
  Register: "/register",
  ForgotPassword: "/forgot_password",
  Verification: "/verification",
  NewPassword: "/new_password",
  CompleteProfile: "/complete-profile",
  Learn: "/learn",
  Dashboard: "/dashboard",
  Leaderboard: "/leaderboard",
  MyLessons: "/my-lessons",
  Lessons: "/lessons",
  Levels: "/maps",
  Exercises: "/maps/exercises",
  Model3D: "/3d_viewer",
  Editor: "/editor",
  Conversations: "/conversations",
  ConversationDetail: "/conversations/:conversationId",
  ConversationsCreateGroup: "/conversations/create-group",
  Feed: "/feed",
  Profile: "/profile",
  Settings: "/settings",
  FinalExam: "/final-exam/:courseId",
};
